import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`

body{
    font-family: poppins;
};
a {
    text-decoration: none;
  }
  a:hover {
    text-decoration: none;
  }
  a:active {
    text-decoration: none;
  }
`;
export const StyledApp = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  .btn-close {
    cursor:pointer;
    position: absolute;
    width: 2.5rem;
    height: 2.5rem;
    padding: .5em .25em!important;
    opacity: 1;
    float:right;
    display:flex;
    justify-self:flex-end;
    background: transparent url(../../../assets/close.svg) center no-repeat;
  }
`;
